import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

const FadeCardImage = ({ src, alt, className = '' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="position-relative image-1x1 bg-light rounded">
      <Card.Img
        src={src}
        alt={alt}
        className={`img-fade-in ${isLoaded ? 'loaded' : ''} ${className}`}
        onLoad={() => setIsLoaded(true)}
        loading="lazy"
        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
      />
    </div>
  );
};

FadeCardImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FadeCardImage;
